import BvHomeView from '../components/public/bv-home-view/bv-home-view';

import WTabBar from '../components/wap/w-tab-bar/w-tab-bar';
import WHomeHeader from '../components/wap/w-home-header/w-home-header';
import WHomeNav from '../components/wap/w-home-nav/w-home-nav';
import config from '@config';

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import VueClipboard from 'vue-clipboard2';

import VeeValidate, { Validator } from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN'// 引入中文文件
// 配置中文
Validator.addLocale(zh)


const validateConfig = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fieldBags',  // 报冲突时 可自定义修改字段名称
  delay: 1000, // 错误提示的延迟时间
  strict: true, // 没有设置规则的表单不进行校验，
  enableAutoClasses: false,
  locale: 'zh_CN', // 对语言（中文）的配置
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input', //* *input|blur** 在用户输入和表单失去焦点时都进行校验 可单独写  blur或input
  inject: true
}


export function useInVueProgram(opts) {

	const { Vue } = opts;

	if (config.device.isWap) {

    Vue.use(VueClipboard)//复制

    Vue.use(VeeValidate, config) //表单验证


    //移动端公共组件
	} else if (config.device.isPc) {
		//PC端公共组件
	}

	//移动端公共组件
  Vue.component('w-tab-bar', WTabBar);
  Vue.component('w-home-header', WHomeHeader);
  Vue.component('w-home-nav', WHomeNav);


	//移动PC公共使用的组件
	Vue.component('bv-home-view', BvHomeView);

	Vue.use(preview)
}



